import { render, staticRenderFns } from "./UserFilter.vue?vue&type=template&id=195fdc52&scoped=true"
import script from "./UserFilter.vue?vue&type=script&lang=ts"
export * from "./UserFilter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195fdc52",
  null
  
)

export default component.exports